import {
  createApiFactory,
  createApiRef,
  createComponentExtension,
  createPlugin,
  DiscoveryApi,
  discoveryApiRef,
  FetchApi,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { unifiedGithubApiRef, UnifiedGithubApi } from '@runway/devkit';
import { rootRouteRef } from './routes';
import { GitHubWorkflowApi, GitHubWorkflowApiClient } from './api';

export const githubWorkflowApiRef = createApiRef<GitHubWorkflowApi>({
  id: 'plugin.github-workflow-ui.service',
});

export const githubWorkflowPlugin = createPlugin({
  id: 'github-workflow-ui',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: githubWorkflowApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        unifiedGithub: unifiedGithubApiRef,
      },
      factory: ({
        discoveryApi,
        fetchApi,
        unifiedGithub,
      }: {
        discoveryApi: DiscoveryApi;
        fetchApi: FetchApi;
        unifiedGithub: UnifiedGithubApi;
      }) =>
        new GitHubWorkflowApiClient({
          discoveryApi,
          fetchApi,
          unifiedGithub,
        }),
    }),
  ],
});

export type { WorkflowDispatchPageProps } from './components/WorkflowDispatchPage';

export const GitHubWorkflowDispatchPage = githubWorkflowPlugin.provide(
  createComponentExtension({
    name: 'GitHubWorkflowDispatchPage',
    component: {
      lazy: () => import('./components/WorkflowDispatchPage').then(m => m.WorkflowDispatchPage),
    },
  }),
);
